import { addNotify } from 'features/notify';

export const StatisticActionDataTypes = {
  ACTION_PROCESSING: 'statistic/ACTION_PROCESSING',
  GET_STATISTIC: 'statistic/GET_STATISTIC',
}

const setActionProcessing = actionProcessing => async (dispatch, getState, extra) => {
  dispatch({
    type: StatisticActionDataTypes.ACTION_PROCESSING,
    payload: { [StatisticActionDataTypes.ACTION_PROCESSING]: { actionProcessing } },
  });
};

const getStatistic = formData => async (dispatch, getState, extra) => {
  const { api } = extra;
  const errorStatusMessage = getState().locale;
  const { isAuth } = getState().auth;

  if (!isAuth) return;

  dispatch(setActionProcessing(true));

  const response = await api.statistic.getStatistic(formData);

  if (response.success) {
    dispatch({
      type: StatisticActionDataTypes.GET_STATISTIC,
      payload: {
        [StatisticActionDataTypes.GET_STATISTIC]: response.data,
      },
    });
  } else {
    const errorMessage = errorStatusMessage[response.codeStatus] ?? (response.errorMessage || errorStatusMessage.defaultMessage);
    addNotify(errorMessage, 'error');
  }

  dispatch(setActionProcessing(false));
};

export { getStatistic };
